/**
 * Generate API endpoint.
 *
 * @param {string} version
 * @param {string} appStack - If version is not v1 then appStack should be required.
 */
export var getApiBaseURL = function getApiBaseURL(version, appStack) {
  var stack = appStack ? appStack + '/' : '';
  var env = process.env.REACT_APP_RM_ENV ? process.env.REACT_APP_RM_ENV : 'dev';

  if (version === 'v1') {
    return getApiEndpoint(env);
  }

  return 'https://liveapi.' + getDomain(env) + '.com/' + stack + version;
};
export var getDomain = function getDomain(env) {
  switch (env) {
    case 'prod':
      return 'roymorgan';

    case 'uat':
      return 'roymorganuat';

    case 'local':
    case 'dev':
    default:
      return 'roymorgandev';
  }
};
/**
 * Generate v1 API endpoint.
 *
 * @deprecated Since version 5.x.
 * Will be made private in a future version.
 * Use getApiBaseURL instead.
 */

export var getApiEndpoint = function getApiEndpoint(appEnv) {
  var env = appEnv ? appEnv : 'dev';
  return 'https://liveapi.' + getDomain(env) + '.com/v1';
};